export const EnrollmentOptions = {
  optIn: {
    optIn: true,
    optOut: false
  },
  optOut: {
    optIn: false,
    optOut: true
  },
  optInNow: {
    optIn: false,
    optOut: false
  }
};
